import { createContext, useContext, useState } from "react";

const AdminAuthContext = createContext(null);

const ADMIN_KEY = "funcard_admin_auth";

export const AdminAuthProvider = ({ children }) => {
    const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(
        () => localStorage.getItem(ADMIN_KEY) === "true"
    );

    const adminLogin = (username, password) => {
        if (username === "Admin" && password === "Annaedkevintom1") {
            localStorage.setItem(ADMIN_KEY, "true");
            setIsAdminAuthenticated(true);
            return true;
        }
        return false;
    };

    const adminLogout = () => {
        localStorage.removeItem(ADMIN_KEY);
        setIsAdminAuthenticated(false);
    };

    return (
        <AdminAuthContext.Provider value={{ isAdminAuthenticated, adminLogin, adminLogout }}>
            {children}
        </AdminAuthContext.Provider>
    );
};

export const useAdminAuth = () => useContext(AdminAuthContext);
